var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import reduceReducers from 'reduce-reducers';
import eventEmitterMiddleware from './event-emitter';
import historyReducer, { historySlice as history } from './history';
import { hubApi } from './services/hub-api';
import { linkApi as linkApiQuery } from './services/link-api';
import amountSelection from './slices/slice-amount-selection';
import adpDirect from './slices/slice-adp-direct';
import bottomSheet from './slices/slice-bottom-sheet';
import ddForm from './slices/slice-dd-form';
import error from './slices/slice-error';
import linkApi from './slices/slice-link-api';
import linkParams from './slices/slice-link-params';
import providerEntity from './slices/slice-provider-entity';
import segment from './slices/slice-segment';
import documentUploads from './slices/slice-document-uploads';
import { searchSlice } from './slices/slice-search';
import supplierEligibility from './slices/slice-supplier-eligibility';
import wizard from './slices/slice-wizard';
import piiData from './slices/slice-pii-data';
var slicesReducer = combineReducers((_a = {
        bottomSheet: bottomSheet,
        adpDirect: adpDirect,
        providerEntity: providerEntity,
        ddForm: ddForm,
        documentUploads: documentUploads,
        segment: segment,
        history: history,
        linkApi: linkApi,
        amountSelection: amountSelection,
        error: error,
        linkParams: linkParams,
        supplierEligibility: supplierEligibility,
        wizard: wizard,
        piiData: piiData
    },
    _a[searchSlice.name] = searchSlice.reducer,
    _a[hubApi.reducerPath] = hubApi.reducer,
    _a[linkApiQuery.reducerPath] = linkApiQuery.reducer,
    _a));
var reducer = reduceReducers(slicesReducer, historyReducer);
var singleton = {};
export var createStore = function (options) {
    singleton.store = configureStore(__assign({ reducer: reducer, 
        /* @ts-ignore */
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware()
                .concat(hubApi.middleware)
                .concat(linkApiQuery.middleware)
                .concat(eventEmitterMiddleware);
        } }, options));
    return singleton.store;
};
export var getStore = function () {
    if (!singleton.store) {
        singleton.store = createStore();
    }
    return singleton.store;
};
export var resetStore = function () {
    singleton.store = null;
};
export var useAppDispatch = useDispatch;
export var useAppSelector = useSelector;
